import React, { Component } from 'react'
import { Row, Col, Space, Form, Input, Switch, Slider, TimePicker, Modal, Select, Typography } from 'antd'
import { ShelterConstants } from '../../../../helpers/enums/Shelter'
import IAddressList from '../../../../interfaces/IAddressList'
import ICountry from '../../../../interfaces/ICountry'
import { FindAddressRequest } from '../../../../services/api/interfaces/ApiRequest'
import { FriscoProvider, Address as Addr } from "@adopets/frisco"
import { loadStorage } from '../../../../services/storage'
import { STORAGE_KEY } from '../../../../context/AuthContext'
import Config from '../../../../config'

type LocationFormProps = {
  addressList: IAddressList[] | null,
  countries: ICountry[] | null,
  countryUuid: string | null,
  loading: boolean,
  form: any,
  parent: any,
  findAddress: (args: FindAddressRequest) => void
  onSelectAddress: (addressList: IAddressList) => void
}

type LocationFormStates = {
  addressRef: any
}

export default class LocationForm extends Component<LocationFormProps, LocationFormStates> {

  static defaultProps = {
    loading: false
  }

  constructor(props) {
    super(props)

    this.state = {
      addressRef: React.createRef<any>()
    }
  }

  componentDidUpdate(prevProps: LocationFormProps) {
    const { form, addressList } = this.props

    // Set address data
    if (!prevProps.addressList && addressList && form) {
      if (addressList.length === 1) {
        this.handleAddressSelection(addressList[0].text)
      }
      if (addressList.length > 1) {
        const addressOptions = addressList?.map(v => {
          return {
            label: v.text,
            value: v.text
          }
        })

        Modal.confirm({
          title: 'We have found more than one address for this zipcode',
          cancelButtonProps: {
            hidden: true
          },
          okText: 'Done',
          content: (
            <Select
              placeholder="Choose the address"
              options={addressOptions}
              onChange={this.handleAddressSelection}
              style={{ width: '100%', marginTop: 15 }}
            />
          )
        })
      }
    }
  }

  handleAddressSelection = (text: string) => {
    const { form, addressList, onSelectAddress } = this.props
    const foundAddress = addressList?.find(v => v.text === text)

    if (foundAddress) {
      const { address, geocode = {}, text } = foundAddress

      const addressFields = Object.keys(address).map(key => {
        return {
          name: ['address', key],
          value: address[key]
        }
      })

      const geocodeFields = Object.keys(geocode).map(key => {
        return {
          name: ['geocode', key],
          value: geocode[key]
        }
      })

      addressFields.push({
        name: ['address', 'street_name'],
        value: text
      })

      form.ref.setFields(addressFields)
      form.ref.setFields(geocodeFields)

      onSelectAddress(foundAddress)
    }
  }

  renderOpeningHours = () => {
    const format: string[] = [
      'HH:mm',
      'HH:mm:ss'
    ]

    return ShelterConstants.DEFAULT_OPENING_HOUR.map((item, index) => {
      return (
        <Row key={index} gutter={24}>
          <Col >
          <div style={{marginTop: 5,minWidth:150}}>{item.name || item.weekday_key}</div>

            <Form.Item
              name={['opening_hour', index, 'weekday_key']}
              hidden={true}
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Row >
            <div style={{marginTop: 5,marginRight:4}}>Closed: </div>
            <Form.Item
              name={['opening_hour', index, 'closed']}
              rules={[]}
            >
              <Switch onChange={(e) => {
                item.closed = e;
                this.forceUpdate();
              }
              }/> 
            </Form.Item>
          </Row>

          <Col >
            <Form.Item
              name={['opening_hour', index, 'opening']}
              hidden={item.closed}
              rules={[
                {
                  required: true,
                  message: 'Please inform the opening hour'
                }
              ]}
            >
              <TimePicker placeholder="Opening" format={format} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item
              name={['opening_hour', index, 'closure']}
              hidden={item.closed}
              rules={[
                {
                  required: true,
                  message: 'Please inform the closure hour'
                }
              ]}
            >
              <TimePicker placeholder="Closed" format={format} />
            </Form.Item>
          </Col>
        </Row>
      )
    })
  }

  renderAddress = (countryCode: string) => {
    const store = loadStorage(STORAGE_KEY)
    const { countries, countryUuid } = this.props
    const country = countries?.find(p => p.uuid === countryUuid)
    let addressCallBackFunction = (address) => {
      thiss.props.parent.setState({ address_uuid: address.uuid });
    };
    const thiss = this;

    return (
      <>
        <Form.Item
          name="address_uuid"
          rules={[
            {
              message: ''
            },
            () => ({
              async validator(_, value) {
                const resutl = await thiss.state.addressRef.current.submit();
                if(!resutl?.uuid){
                  this.message = "";
                }
              }
            })
          ]}
        >
          <FriscoProvider>
            {country?.json.address_config && <Addr
              apiConfig={{
                serviceUrl: Config.serviceAPI,
                globalUrl: Config.globalAPI,
              }}
              fieldsConfig={{
                country: { hidden: true }
              }}
              token={store.accessToken}
              country={{
                uuid: country.uuid,
                name: country.name,
                json: country.json
              }}
              ref={thiss.state.addressRef}
              onSendData={addressCallBackFunction} />}
          </FriscoProvider>
        </Form.Item>
      </>
    )
  }

  render() {
    const { countries, countryUuid } = this.props
    const country = countries?.find(p => p.uuid === countryUuid)
    console.log(this.state)

    return (
      <Col>
        <Col xs={24} sm={20} md={20}>
          <Form.Item
            label="Location name. This will be the first location of the shelter."
            name="name"
            rules={[
              {
                required: true,
                message: 'Required field'
              }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Max Radius Distance. An old Adopets functionality that was relevant when we had a public search page to search by zipcode. But as shelters rely on iframes on their website, this is no longer relevant. So by default, we can leave it a 0."
            name="max_distance"
          >
            <Slider max={1000} />
          </Form.Item>

          <Space direction="horizontal" size={24}>
            <Form.Item
              label="Headquarter"
              name="headquarter"
              valuePropName="checked"
            >
              <Switch defaultChecked={true} />
            </Form.Item>

            <Form.Item
              label="Active"
              name="active"
              valuePropName="checked"
            >
              <Switch defaultChecked={true} />
            </Form.Item>
          </Space>

          <Typography.Title level={4}>Open hours</Typography.Title>
          <Typography.Text>Configure the open hours of this location.</Typography.Text>
            <br/><br/>
          {
            this.renderOpeningHours()
          }
        </Col>

        <Col xs={24} sm={12} md={12}>
          <Space direction="horizontal" size={24}>
            <Form.Item
              label="Location email. All new adoption inquiries notifications will be sent to this email."
              name={['contact', 'email']}
              rules={[
                {
                  required: true,
                  message: 'Required field'
                },
                {
                  type: 'email',
                  message: 'Invalid email'
                }
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Location phone number"
              name={['contact', 'work_phone']}
              rules={[
                {
                  required: true,
                  message: 'Required field'
                }
              ]}
            >
              <Input type="number" />
            </Form.Item>
          </Space>

          {
            this.renderAddress(country?.code.toLowerCase() || 'us')
          }
        </Col>
      </Col>
    )
  }
}
